export const BookRegisterSymbol = Symbol('bookRegister');
